import { ThankYouStyledSocialButton } from './styles'

interface ThankYouSocialButtonProps {
    src: string
    alt: string
    link: string
}

export const ThankYouSocialButton = ({
    alt,
    src,
    link,
}: ThankYouSocialButtonProps) => (
    <ThankYouStyledSocialButton href={link} target="_blank" rel="dofollow">
        <img src={src} alt={alt} />
    </ThankYouStyledSocialButton>
)
